<template>
  <div>
    <div class="btnGroup">
      <el-button type="primary" @click="pdfRotate()">旋转</el-button>
      <el-button type="primary" @click="pdfRotate1()">反向旋转</el-button>
      <el-button type="primary" @click="fileDownload(pdfUrl, 'pdf文件')">下载</el-button>
      <!--      <el-button v-if="!flag &&showButton" type="primary" @click="fullScreen">全屏</el-button>-->
      <!--      <el-button v-if="flag && showButton" type="primary" @click="fullScreen">还原</el-button>-->
      <!--      <el-button type="primary" @click="pdfPrintAll()">打印</el-button>-->
    </div>
    <el-divider/>
    <div ref="pdfView" class="process-fileView-pdf-container">
      <div id="printContent" v-if="showPreviewFile" style="margin-top:5px;height: 600px;overflow-y: auto;">
        <pdf
            ref="pdf"
            v-for="i in numPages"
            :key="i+'pdf'"
            render-page="0"
            :rotate="pageRotate"
            :src="src"
            :page="i"
            style="width: 100%"/>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import pdf from "vue-pdf";

  export default {
    name: "vue_pdf_preview1",
    props: {
      // 当前pdf路径
      pdfUrl: {
        type: String,
        default: "",
      },
    },

    components: {
      pdf,
    },

    data() {
      return {
        src: "",
        numPages: 1,
        showPreviewFile: true,
        pageRotate: 0,
      };
    },
    watch: {
      pdfUrl: {
        immediate: true,
        handler(newVal, oldVal) {
          if (newVal && newVal != oldVal) {
            this.previewFile();
          }
        },
      },
    },
    mounted() {
      this.previewFile();
    },

    methods: {
      pdfRotate() {
        this.pageRotate += 90;
      },
      pdfRotate1() {
        this.pageRotate -= 90;
      },

      //下载PDF
      fileDownload(data, fileName) {
        window.open(this.pdfUrl);
      },
      // 打印所有
      pdfPrintAll() {
        // this.$refs.print.
        // document.body.innerHTML = document.getElementById("printContent").parentNode.innerHTML;
        // window.print();
        // window.location.reload();
        // return false;
      },

      /** pdf加载 */
      async previewFile() {
        try {
          // this.showPreviewFile = false;
          let loadingTask = pdf.createLoadingTask({
            url: this.pdfUrl,
            // CMapReaderFactory,
          });
          loadingTask.promise.then(pdf => {
            this.src = loadingTask;
            // this.showPreviewFile = true;
            this.numPages = pdf.numPages;
            this.pageRotate = 0;
          }).catch((e) => {
            console.log("pdf初始化错误", e);
          });
          // loadingTask.destroy();
        } catch (e) {
          // this.$router.go(-1);
          console.log("pdf加载出错了", e);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>

.btnGroup {
  text-align: right;
  margin-bottom: 5px;
  margin-right: 8px;
  margin-top: 0px;
}

.process-fileView-pdf-container {
  margin-top: 20px;
  width: 100%;
  height: 100%;

}


.progress {
  position: absolute;
  right: 50%;
  top: 50%;
  text-align: center;
}

.progress > span {
  color: #199edb;
  font-size: 14px;
}

</style>
